export default __webpack_public_path__ + "static/media/nestleLogo.17e6166a.png";